import React, { createContext, useState, useEffect } from "react";

export const FontSizeContext = createContext();

export const FontSizeProvider = ({ children }) => {
  const [fontSize, setFontSize] = useState(100); 

  
  useEffect(() => {
    document.documentElement.style.fontSize = `${fontSize}%`;
  }, [fontSize]);

  const increaseFont = () => setFontSize((prev) => Math.min(prev + 10, 200)); 
  const decreaseFont = () => setFontSize((prev) => Math.max(prev - 10, 60)); 
  const resetFont = () => setFontSize(100);

  return (
    <FontSizeContext.Provider
      value={{ fontSize, increaseFont, decreaseFont, resetFont }}
    >
      {children}
    </FontSizeContext.Provider>
  );
};
